var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommunityGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 75,
    viewBox: "0 0 249 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.6851C0 18.5983 4.12369 14.4746 9.21053 14.4746C14.2974 14.4746 18.4211 18.5983 18.4211 23.6851V65.7904C18.4211 70.8772 14.2974 75.0009 9.21053 75.0009C4.12369 75.0009 0 70.8772 0 65.7904V23.6851Z",
    fill: "url(#paint0_linear_1_609)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4209 30.2633C38.4209 25.1764 42.5446 21.0527 47.6314 21.0527C52.7183 21.0527 56.8419 25.1764 56.8419 30.2633V65.7896C56.8419 70.8764 52.7183 75.0001 47.6314 75.0001C42.5446 75.0001 38.4209 70.8764 38.4209 65.7896V30.2633Z",
    fill: "url(#paint1_linear_1_609)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8418 59.2105C76.8418 54.1237 80.9655 50 86.0523 50C91.1392 50 95.2628 54.1237 95.2628 59.2105V65.7895C95.2628 70.8763 91.1392 75 86.0523 75C80.9655 75 76.8418 70.8763 76.8418 65.7895V59.2105Z",
    fill: "url(#paint2_linear_1_609)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.263 35.5269C115.263 30.4401 119.386 26.3164 124.473 26.3164C129.56 26.3164 133.684 30.4401 133.684 35.5269V50.6585V65.7901C133.684 70.8769 129.56 75.0006 124.473 75.0006C119.386 75.0006 115.263 70.8769 115.263 65.7901V35.5269Z",
    fill: "url(#paint3_linear_1_609)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.684 52.6324C153.684 47.5456 157.807 43.4219 162.894 43.4219C167.981 43.4219 172.105 47.5456 172.105 52.6324V65.7903C172.105 70.8771 167.981 75.0008 162.894 75.0008C157.807 75.0008 153.684 70.8771 153.684 65.7903V52.6324Z",
    fill: "url(#paint4_linear_1_609)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M192.104 30.2633C192.104 25.1764 196.228 21.0527 201.315 21.0527C206.402 21.0527 210.526 25.1764 210.526 30.2633V65.7896C210.526 70.8764 206.402 75.0001 201.315 75.0001C196.228 75.0001 192.104 70.8764 192.104 65.7896V30.2633Z",
    fill: "url(#paint5_linear_1_609)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M230.525 9.21053C230.525 4.12369 234.649 0 239.736 0C244.823 0 248.946 4.12369 248.946 9.21053V65.7895C248.946 70.8763 244.823 75 239.736 75C234.649 75 230.525 70.8763 230.525 65.7895V9.21053Z",
    fill: "url(#paint6_linear_1_609)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_609",
    x1: 132.5,
    y1: 29,
    x2: 133,
    y2: 100.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_609",
    x1: 132.5,
    y1: 29,
    x2: 133,
    y2: 100.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_609",
    x1: 132.5,
    y1: 29,
    x2: 133,
    y2: 100.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_609",
    x1: 132.5,
    y1: 29,
    x2: 133,
    y2: 100.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_609",
    x1: 132.5,
    y1: 29,
    x2: 133,
    y2: 100.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_609",
    x1: 132.5,
    y1: 29,
    x2: 133,
    y2: 100.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_609",
    x1: 132.5,
    y1: 29,
    x2: 133,
    y2: 100.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityGraph);
export default __webpack_public_path__ + "static/media/community-graph.6a62d7948eaf75353ccc6a80fb832c32.svg";
export { ForwardRef as ReactComponent };